export const reqStatusTypes = {
    idle: 'IDLE',
    pending: 'PENDING',
    succeeded: 'SUCCEEDED',
    failed: 'FAILED',
};
